<template>
  <div class="reset-container">
    <div class="reset-card">

      <div class="login-header">
        <img src="../../assets/logo-planos.png" alt="Logo Planos" class="logo-planos" />
        <h2><b>NCM</b> <span>Helper</span></h2>
        <p class="subtitle">Redefinir senha</p>
      </div>

      <div v-if="loadingToken" class="subtitle">
        Validando token...
      </div>

      <div v-else>
        <div class="form-group">
          <input
            type="password"
            v-model="senha"
            placeholder="Nova senha"
            :class="{ 'input-error': erroSenha }"
          />
        </div>

        <div class="form-group">
          <input
            type="password"
            v-model="confirmarSenha"
            placeholder="Confirmar senha"
            :class="{ 'input-error': erroSenha }"
            
          />
        </div>

        <small v-if="erroSenha" class="error-text">
          {{ erroSenha }}
        </small>

        <button
          class="btn-confirm"
          @click="resetarSenha"
          :disabled="loading"
        >
          {{ loading ? 'Alterando...' : 'Salvar nova senha' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import NcmUsuarioService from '../../services/NcmUsuarioService'

export default {
  name: 'ResetPassword',

  data() {
    return {
      senha: '',
      confirmarSenha: '',
      erroSenha: '',
      loading: false,
      loadingToken: true,
      token: ''
    }
  },

  async mounted() {
    this.token = this.$route.query.token

    if (!this.token) {
      this.$messages.error('Token inválido ou não informado')
      this.$router.replace('/login')
      return
    }

    try {
      await NcmUsuarioService.validateToken({
        token: this.token
      })

    } catch (e) {
      this.$messages.error('Token expirado ou inválido')
      this.$router.replace('/login')
      return
    } finally {
      this.loadingToken = false
    }
  },

  methods: {
    async resetarSenha() {
      try {
        this.erroSenha = ''

        if (!this.senha || !this.confirmarSenha) {
          this.erroSenha = 'Preencha todos os campos'
          return
        }

        if (this.senha.length < 6) {
          this.erroSenha = 'A senha deve ter pelo menos 6 caracteres'
          return
        }

        if (this.senha !== this.confirmarSenha) {
          this.erroSenha = 'As senhas não coincidem'
          return
        }

        this.loading = true

        await NcmUsuarioService.updateUserPassword({
          token: this.token,
          security: {
            senha: this.senha,
            confirmarSenha: this.confirmarSenha
          }
        })

        this.$messages.success('Senha alterada com sucesso!')
        this.$router.push('/login')

      } catch (e) {
        this.$messages.error(
          e.message || e.data?.message || 'Erro ao alterar senha'
        )
      } finally {
        this.loading = false
      }
    },
    
  }
}
</script>

<style>
.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.logo-planos {
  width: 60px;
  margin-bottom: 10px;
}

.login-header h2 {
  margin: 0;
  font-size: 20px;
}

.login-header span {
  color: #3c8dbc;
}
.reset-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #3c8dbc, #3c8dbc);
}

.reset-card {
  background: #fff;
  width: 350px;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 12px;
}

input {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.input-error {
  border: 1px solid red;
}

.error-text {
  color: red;
  font-size: 12px;
  margin-bottom: 10px;
  display: block;
}

.btn-confirm {
  width: 100%;
  padding: 12px;
  background: #3c8dbc;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.btn-confirm:hover {
  background: #47ace6;
}

.btn-confirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>